import React from 'react';
import { FormTemplateHeader, FormTemplateSectionWrapper } from '../../others/'

import Address from './Address'

const PersonalInformation = (props) => {
  const { template, isTemplate, homeSelectedCountry, homeRegions, officeSelectedCountry, officeRegions } = props
  return (
    <div>
      {template && template.personal_information &&
        <div>
          <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.address_details}>
            <div className="row mx-0 mt-7 bg-white shadow-sm">
              <div className="col-12 px-5">
                <FormTemplateHeader
                  isTemplate={isTemplate}
                  fieldValues={template.personal_information.address_details}
                  baseName="personal_information[address_details]"
                />
              </div>
              <div className="col-12 px-7 pt-5">
                <div className="row">
                  <div className='col-12'>
                    <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.address_details.home_address}>
                      <div className="row">
                        <div className="col-12 px-0 mb-4">
                          <FormTemplateHeader
                            isTemplate={isTemplate}
                            fieldValues={template.personal_information.address_details.home_address}
                            baseName="personal_information[address_details][home_address]"
                            wrapperClasses="sub-header-alignment"
                          />
                        </div>
                        <Address
                          isTemplate={isTemplate}
                          addressType="home"
                          selectedCountry={homeSelectedCountry}
                          regions={homeRegions}
                          basePatientName="home_address_attributes"
                          baseTemplateName="personal_information[address_details][home_address][fields]"
                          baseFieldValues={template.personal_information.address_details.home_address.fields}
                        />
                      </div>
                    </FormTemplateSectionWrapper>
                  </div>
                  <div className='col-12'>
                    <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.address_details.office_address}>
                      <div className='row'>
                        <div className="col-12 px-0 mb-4">
                          <FormTemplateHeader
                            isTemplate={isTemplate}
                            fieldValues={template.personal_information.address_details.office_address}
                            baseName="personal_information[address_details][office_address]"
                          />
                        </div>
                        <Address
                          isTemplate={isTemplate}
                          addressType="office"
                          selectedCountry={officeSelectedCountry}
                          regions={officeRegions}
                          basePatientName="office_address_attributes"
                          baseTemplateName="personal_information[address_details][office_address][fields]"
                          baseFieldValues={template.personal_information.address_details.office_address.fields}
                        />
                      </div>
                    </FormTemplateSectionWrapper>
                  </div>
                </div>
              </div>
            </div>
          </FormTemplateSectionWrapper>
        </div>
      }
    </div>
  )
}

export default PersonalInformation;
